import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 56 }} spin />;

function ComLoading() {
  return (
    <div className="display-flex jc-center item-center full-width full-height loading-wrapper">
      <Spin size="large" indicator={antIcon} />
    </div>
  );
}

export default ComLoading;
